import React, { useState } from 'react';
import Linkpages from "./Linkpages";
import '../css/vagadent.css';
import '../css/media.css';
import '../css/services.css';

import { useTranslation } from "react-i18next";

function Services(props) {
    const { t, i18n } = useTranslation("common");
    const [menuOpen, setMenuOpen] = useState(false);

    // State՝ բացված ծառայության ID-ն պահելու համար (null նշանակում է բոլորը փակ են)
    const [activeCategory, setActiveCategory] = useState(null);

    // 1. Ծառայությունների հերթականությունը՝ ճիշտ քո ուզածով
    const categories = ['therapy', 'orthopedics', 'surgery', 'implants', 'cleaning_whitening'];

    // 2. Նկարագրությունների օբյեկտ՝ ըստ ընտրված լեզվի (i18n.language)
    const descriptions = {
        hay: {
            therapy: (
                <div>
                    <p>
                        «ՎաԳաԴենտ» կլինիկայում ատամների բուժումն իրականացվում է լիովին <i>անցավ, արագ և հարմարավետ</i> միջավայրում։ Ժամանակակից որակյալ նյութերի շնորհիվ պատրաստի պլոմբան իր գույնով ու ձևով բնական ատամից ընդհանրապես չի տարբերվում։ Բուժումը կատարվում է <i>անհատական մոտեցմամբ</i> և բարձր պատասխանատվությամբ:
                    </p>
                    <div style={{ marginTop: '15px', fontWeight: '500', color: '#84A98C' }}>Թերապևտիկ ծառայությունները ներառում են.</div>
                    <ul className="service-sub-list">
                        <li>✓ Կարիեսի բուժում</li>
                        <li>✓ Ատամների պլոմբավորում (հելիոպլոմբ)</li>
                        <li>✓ Արմատային խողովակների բուժում և լեցում</li>
                        <li>✓ Պուլպիտի բուժում</li>
                        <li>✓ Ատամնային նյարդի անցավ հեռացում</li>
                    </ul>
                </div>
            ),
            orthopedics: (
                <div>
                <p>
                    «ՎաԳաԴենտ» կլինիկայում օրթոպեդիկ ստոմատոլոգիան ուղղված է ժպիտի գեղեցկության և ծամողական ֆունկցիայի նուրբ ու կատարյալ վերականգնմանը։ Ժամանակակից մեթոդները թույլ են տալիս վերականգնել նույնիսկ ուժեղ վնասված կամ բացակայող ատամները։ Օգտագործվում են բարձր որակի և կենսահամատեղելի նյութեր, որոնք ապահովում են առավելագույն ամրություն և բնական էսթետիկա՝ անհատական մոտեցմամբ:
                </p>
                <div style={{ marginTop: '15px', color: '#84A98C' }}>Օրթոպեդիկ ծառայությունները ներառում են.</div>
                <ul className="service-sub-list">
                    <li>✓ Ցիրկոնիումե բարձրակարգ պսակներ (կորոնկաներ) և կամուրջներ</li>
                    <li>✓ Մետաղակերամիկական ամուր պսակների պատրաստում</li>
                    <li>✓ Ատամների էսթետիկ վերականգնում վինիրներով</li>
                    <li>✓ Շարժական և անշարժ լրիվ ու մասնակի պրոթեզներ</li>
                    <li>✓ Պրոթեզավորում իմպլանտների վրա</li>
                </ul>
            </div>
            ),
            surgery:(
                <div>
                    <p>
                        «ՎաԳաԴենտ» կլինիկայում վիրաբուժական միջամտություններն իրականացվում են առավելագույնս խնայողաբար և անվտանգության բոլոր կանոնների խստիվ պահպանմամբ։ Յուրաքանչյուր գործողություն կատարվում է բարձրագույն ճշգրտությամբ, ինչը երաշխավորում է արագ լավացում և հետվիրահատական հարմարավետ շրջան:
                    </p>
                    <div style={{ marginTop: '15px', color: '#84A98C' }}>Վիրաբուժական ծառայությունները ներառում են.</div>
                    <ul className="service-sub-list">
                        <li>✓ Ցանկացած բարդության ատամների հեռացում</li>
                        <li>✓ Իմաստության ատամների հեռացում</li>
                        <li>✓ Ռետենցված (չծագած) ատամների հեռացում</li>
                        <li>✓ Լնդային վիրահատություններ և պլաստիկա</li>
                        <li>✓ Բերանի խոռոչի նախապատրաստում պրոթեզավորման կամ իմպլանտացիայի</li>
                    </ul>
                </div>
            ),
            implants:(

                    <div>
                        <p>
                            «ՎաԳաԴենտ» կլինիկայում ատամնային իմպլանտացիան իրականացվում է առաջատար տեխնոլոգիաների և բարձրակարգ կենսահամատեղելի նյութերի կիրառմամբ: Սա թույլ է տալիս լիովին վերականգնել մեկ կամ մի քանի բացակայող ատամները՝ չվնասելով հարևան առողջ ատամները: Միջամտությունը կատարվում է բարձր ճշգրտությամբ՝ ապահովելով հուսալի, երկարատև արդյունք և բնական ժպիտ:
                        </p>
                        <div style={{ marginTop: '15px', color: '#84A98C' }}>Իմպլանտոլոգիական ծառայությունները ներառում են.</div>
                        <ul className="service-sub-list">
                            <li>✓ Բարձրակարգ ատամնային իմպլանտների տեղադրում</li>
                            <li>✓ Ոսկրային հյուսվածքի վերականգնում և աճեցում (ոսկրային պլաստիկա)</li>
                            <li>✓ Սինուս-լիֆտինգ (հայմորյան խոռոչի հատակի բարձրացում)</li>
                            <li>✓ Պրոթեզավորում իմպլանտների վրա (ցիրկոնիումե և մետաղակերամիկական պսակներ)</li>
                            <li>✓ Ամբողջական ծնոտի վերականգնում իմպլանտներով</li>
                        </ul>
                    </div>
            ),
            cleaning_whitening:(
                <div>
                    <p>
                        «ՎաԳաԴենտ» կլինիկայում ատամների պրոֆեսիոնալ մաքրումն ու սպիտակեցումն ուղղված են ժպիտի ակնթարթային գեղեցկությանը և բերանի խոռոչի առողջությանը: Ժամանակակից անվտանգ մեթոդների շնորհիվ հեռացվում են ատամնանստվածքներն ու փառը, իսկ սպիտակեցման պրոցեդուրան թույլ է տալիս անվնաս կերպով ստանալ մի քանի տոնով ավելի սպիտակ ու փայլուն ժպիտ:
                    </p>
                    <div style={{ marginTop: '15px', color: '#84A98C' }}>Ծառայությունները ներառում են.</div>
                    <ul className="service-sub-list">
                        <li>✓ Ատամնաքարերի հեռացում ուլտրաձայնային եղանակով</li>
                        <li>✓ Ատամների մակերեսի պրոֆեսիոնալ փայլեցում հատուկ մածուկներով</li>
                        <li>✓ Ատամների անվտանգ կլինիկական սպիտակեցում</li>
                    </ul>
                </div>
            ),
        },
        ru: {
            therapy: (
                <div>
                    <p>
                        В клинике «ВаГаДент» лечение зубов проходит в абсолютно безболезненной, быстрой и комфортной атмосфере. Благодаря современным качественным материалам готовая пломба по своему цвету и форме совершенно не отличается от естественного зуба. Лечение проводится с высокой индивидуальной ответственностью.
                    </p>
                    <div style={{ marginTop: '15px', color: '#84A98C' }}>Терапевтические услуги включают:</div>
                    <ul className="service-sub-list">
                        <li>✓ Лечение кариеса</li>
                        <li>✓ Пломбирование зубов (гелиопломба)</li>
                        <li>✓ Лечение и пломбирование корневых каналов</li>
                        <li>✓ Лечение пульпита</li>
                        <li>✓ Безболезненное удаление зубного нерва</li>
                    </ul>
                </div>
            ),
            orthopedics: (
                <div>
                    <p>
                        В клинике «ВаГаДент» ортопедическая стоматология направлена на бережное и совершенное восстановление красоты улыбки и жевательной функции. Современные методы позволяют восстановить даже сильно поврежденные или отсутствующие зубы. Используются высококачественные и биосовместимые материалы, обеспечивающие максимальную прочность и естественную эстетику.
                    </p>
                    <div style={{ marginTop: '15px', color: '#84A98C' }}>Ортопедические услуги включают:</div>
                    <ul className="service-sub-list">
                        <li>✓ Высококлассные циркониевые коронки и мостовидные протезы</li>
                        <li>✓ Прочные металлокерамические коронки</li>
                        <li>✓ Эстетическое восстановление зубов винирами</li>
                        <li>✓ Съемные и несъемные полные и частичные протезы</li>
                        <li>✓ Протезирование на имплантах</li>
                    </ul>
                </div>
            ),
            surgery: (
                <div>
                    <p>
                        В клинике «ВаГаДент» хирургические вмешательства проводятся максимально бережно и при строгом соблюдении всех правил безопасности. Каждая процедура выполняется с высокой точностью, что гарантирует быстрое заживление и комфортный послеоперационный период.
                    </p>
                    <div style={{ marginTop: '15px', color: '#84A98C' }}>Хирургические услуги включают:</div>
                    <ul className="service-sub-list">
                        <li>✓ Удаление зубов любой сложности</li>
                        <li>✓ Удаление зубов мудрости</li>
                        <li>✓ Удаление ретенированных (непрорезавшихся) зубов</li>
                        <li>✓ Хирургия и пластика десен</li>
                        <li>✓ Подготовка полости рта к протезированию или имплантации</li>
                    </ul>
                </div>
            ),
            implants: (
                <div>
                    <p>
                        В клинике «ВаГаДент» имплантация зубов проводится с использованием передовых технологий и высококачественных биосовместимых материалов. Это позволяет полностью восстановить один или несколько отсутствующих зубов, не повреждая соседние здоровые зубы. Процедура выполняется с высокой точностью, обеспечивая надежный, долговечный результат и естественную улыбку.
                    </p>
                    <div style={{ marginTop: '15px', color: '#84A98C' }}>Имплантологические услуги включают:</div>
                    <ul className="service-sub-list">
                        <li>✓ Установка дентальных имплантов премиум-класса</li>
                        <li>✓ Восстановление и наращивание костной ткани (костная пластика)</li>
                        <li>✓ Синус-лифтинг (поднятие дна гайморовой пазухи)</li>
                        <li>✓ Протезирование на имплантах (циркониевые и металлокерамические коронки)</li>
                        <li>✓ Полное восстановление челюсти на имплантах</li>
                    </ul>
                </div>
            ),
            orthodontics: (
                <div>
                    <p>
                        Ортодонтическое лечение в клинике «ВаГаДент» помогает обрести идеально ровный зубной ряд и правильный прикус. Современные ортодонтические системы позволяют эффективно исправлять любые неровности как у детей, так и у взрослых, обеспечивая здоровую, красивую улыбку и гармоничные черты лица.
                    </p>
                    <div style={{ marginTop: '15px', color: '#84A98C' }}>Ортодонтические услуги включают:</div>
                    <ul className="service-sub-list">
                        <li>✓ Установка металлических и керамических брекет-систем</li>
                        <li>✓ Невидимое выравнивание прозрачными элайнерами Инвизилайн (Invisalign)</li>
                        <li>✓ Исправление прикуса у детей с помощью специальных пластинок</li>
                        <li>✓ Устранение диастем (промежутков между зубами)</li>
                    </ul>
                </div>
            ),
            cleaning_whitening: (
                <div>
                    <p>
                        Профессиональная чистка и отбеливание зубов в клинике «ВаГаДент» направлены на мгновенную красоту улыбки и здоровье полости рта. Благодаря современным безопасным методам удаляются зубные отложения и налет, а процедура отбеливания позволяет безвредно сделать улыбку на несколько тонов светлее и ярче.
                    </p>
                    <div style={{ marginTop: '15px', color: '#84A98C' }}>Услуги включают:</div>
                    <ul className="service-sub-list">
                        <li>✓ Удаление зубного камня ультразвуковым методом</li>
                        <li>✓ Профессиональная полировка поверхности зубов специальными пастами</li>
                        <li>✓ Безопасное клиническое отбеливание зубов</li>
                    </ul>
                </div>
            ),
        },
        en: {
            therapy: (
                <div>
                    <p>
                        At "VaGaDent" clinic, dental treatment is carried out in a completely painless, fast, and comfortable environment. Thanks to modern, high-quality materials, the final filling perfectly matches the natural tooth in color and shape. Treatment is performed with high individual responsibility.
                    </p>
                    <div style={{ marginTop: '15px', color: '#84A98C' }}>Therapeutic services include:</div>
                    <ul className="service-sub-list">
                        <li>✓ Caries treatment</li>
                        <li>✓ Dental filling (composite filling)</li>
                        <li>✓ Root canal treatment and sealing</li>
                        <li>✓ Pulpitis treatment</li>
                        <li>✓ Painless dental nerve removal</li>
                    </ul>
                </div>
            ),
            orthopedics: (
                <div>
                    <p>
                        At "VaGaDent" clinic, orthopedic dentistry is aimed at the gentle and perfect restoration of smile aesthetics and chewing function. Modern methods allow the restoration of even severely damaged or missing teeth. High-quality, biocompatible materials are used to ensure maximum durability and natural aesthetics.
                    </p>
                    <div style={{ marginTop: '15px', color: '#84A98C' }}>Orthopedic services include:</div>
                    <ul className="service-sub-list">
                        <li>✓ Premium zirconium crowns and bridges</li>
                        <li>✓ Durable metal-ceramic crowns</li>
                        <li>✓ Aesthetic dental restoration with veneers</li>
                        <li>✓ Removable and fixed full and partial dentures</li>
                        <li>✓ Prosthetics on implants</li>
                    </ul>
                </div>
            ),
            surgery: (
                <div>
                    <p>
                        At "VaGaDent" clinic, surgical interventions are performed as gently as possible, strictly adhering to all safety regulations. Each procedure is executed with high precision, guaranteeing fast healing and a comfortable post-operative period.
                    </p>
                    <div style={{ marginTop: '15px', color: '#84A98C' }}>Surgical services include:</div>
                    <ul className="service-sub-list">
                        <li>✓ Tooth extraction of any complexity</li>
                        <li>✓ Wisdom teeth extraction</li>
                        <li>✓ Impacted (unerupted) teeth extraction</li>
                        <li>✓ Gingival surgery and plastic procedures</li>
                        <li>✓ Preparation of the oral cavity for prosthetics or implantation</li>
                    </ul>
                </div>
            ),
            implants: (
                <div>
                    <p>
                        At "VaGaDent" clinic, dental implantation is performed using advanced technologies and premium biocompatible materials. This allows for the complete restoration of one or more missing teeth without damaging adjacent healthy teeth. The procedure is carried out with high precision, ensuring reliable, long-lasting results and a natural smile.
                    </p>
                    <div style={{ marginTop: '15px', color: '#84A98C' }}>Implantology services include:</div>
                    <ul className="service-sub-list">
                        <li>✓ Placement of premium dental implants</li>
                        <li>✓ Bone graft and bone tissue regeneration</li>
                        <li>✓ Sinus lift (elevation of the maxillary sinus floor)</li>
                        <li>✓ Prosthetics on implants (zirconium and metal-ceramic crowns)</li>
                        <li>✓ Full arch restoration with implants</li>
                    </ul>
                </div>
            ),
            orthodontics: (
                <div>
                    <p>
                        Orthodontic treatment at "VaGaDent" clinic helps to achieve a perfectly aligned dentition and a correct bite. Modern orthodontic systems effectively correct any irregularities in both children and adults, ensuring a healthy, beautiful smile and harmonious facial features.
                    </p>
                    <div style={{ marginTop: '15px', color: '#84A98C' }}>Orthodontic services include:</div>
                    <ul className="service-sub-list">
                        <li>✓ Placement of metal and ceramic brace systems</li>
                        <li>✓ Invisible alignment with Invisalign clear aligners</li>
                        <li>✓ Bite correction for children using special plates</li>
                        <li>✓ Elimination of diastemas (gaps between teeth)</li>
                    </ul>
                </div>
            ),
            cleaning_whitening: (
                <div>
                    <p>
                        Professional dental cleaning and whitening at "VaGaDent" clinic are aimed at instant smile enhancement and oral cavity health. Thanks to modern safe methods, dental plaque and calculus are removed, while the whitening procedure harmlessly brightens the smile by several shades.
                    </p>
                    <div style={{ marginTop: '15px', color: '#84A98C' }}>Services include:</div>
                    <ul className="service-sub-list">
                        <li>✓ Ultrasonic tartar removal</li>
                        <li>✓ Professional polishing of tooth surfaces with special pastes</li>
                        <li>✓ Safe clinical teeth whitening</li>
                    </ul>
                </div>
            ),
        }
    };

    const toggleCategory = (id) => {
        if (activeCategory === id) {
            setActiveCategory(null); // Եթե նույնի վրա է սեղմում՝ փակել
        } else {
            setActiveCategory(id); // Բացել սեղմվածը
        }
    };

    // Ընթացիկ լեզուն ստանալու համար (եթե չգտնի, դեֆոլտ կվերցնի հայերենը)
    const currentLang = i18n.language || 'hay';

    return (
        <div className="home-wrapper">
            <div className="header-container">
                <div className="logo-group">
                    <div className="logo"></div>
                    <div className="brand-text">
                        <div className="vagadent">{t('welcome.title')}</div>
                        <div className="dental">{t('welcome.title1')}</div>
                    </div>
                </div>

                {/* Մոբայլ դասը ավելացված է, որ կառավարվի media-ով */}
                <div className={`nav-menu ${menuOpen ? 'open' : ''}`}>
                    <Linkpages />
                </div>

                <div className="header-right">
                    <div className="leng">
                        <button onClick={()=>i18n.changeLanguage('hay')}>ՀԱՅ</button>
                        <button onClick={()=>i18n.changeLanguage('ru')}>РУ</button>
                        <button onClick={()=>i18n.changeLanguage('en')}>ENG</button>
                    </div>
                    {/* Մոբայլի մենյուի կոճակը (բուրգեր) */}
                    <div className={`menu-dots ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>

            {/* ==========================================
               ԱՎԵԼԱՑՎԱԾ ԲԱԺԻՆԸ՝ ԾԱՌԱՅՈՒԹՅՈՒՆՆԵՐԻ ԱԿՈՐԴԵՈՆ
               ========================================== */}
            <div className="services-page-container">
                <div className="services-wrapper">

                    {/* Էջի Վերնագիրը */}
                    <div className="services-title-block">
                        <h2 className="services-title">{t('menu.services')}</h2>
                        <div className="services-line"></div>
                    </div>

                    {/* Ակորդեոն Համակարգը */}
                    <div className="accordion-container">
                        {categories.map((cat) => {
                            const isOpen = activeCategory === cat;
                            return (
                                <div
                                    className={`accordion-item ${isOpen ? 'active' : ''}`}
                                    key={cat}
                                >
                                    {/* Գլխամաս՝ սեղմվող հատվածը */}
                                    <div
                                        className="accordion-header"
                                        onClick={() => toggleCategory(cat)}
                                    >
                                        {/* Տեքստը կանչում ենք քո պարզ JSON-ից */}
                                        <span className="category-name">{t(`services.${cat}`)}</span>
                                        <span className="accordion-icon">{isOpen ? '−' : '+'}</span>
                                    </div>

                                    {/* Սահուն բացվող տեքստի հատվածը */}
                                    <div className="accordion-collapse">
                                        <div className="accordion-body">
                                            <p className="service-description">
                                                {/* Տեքստը վերցնում ենք վերևի հայերեն/ռուսերեն/անգլերեն օբյեկտից */}
                                                {descriptions[currentLang]?.[cat] || descriptions['hay'][cat]}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                </div>
            </div>
        </div>
    );
}

export default Services;